<template>
  <section class="p-2 bg-light rounded shadow border-start-blue mb-2">
    <h5 class="fw-bold text-primary mb-2">Agendamento do Envio</h5>

    <b-row>
      <b-col cols="6">
        <validation-provider #default="{ errors }" name="Periodicidade" rules="required">
          <b-form-group
            label="Periodicidade*"
            label-for="periodicidade"
            :state="errors.length > 0 || form.errors.periodicidade ? false : null"
          >
            <v-select
              id="periodicidade"
              :value="form.periodicidade"
              @input="$emit('update:periodicidade', $event)"
              :options="optionsPeriodicidade"
              :clearable="false"
              placeholder="Selecione a periodicidade"
              class="bg-white"
              :disabled="!permiteGerenciar"
            >
              <span slot="no-options">Nenhuma opção disponível.</span>
            </v-select>
            <small v-if="errors[0]" class="text-danger d-block">Este campo é de preenchimento obrigatório.</small>
            <small v-if="form.errors.periodicidade" class="text-danger">{{ form.errors.periodicidade }}</small>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col cols="6">
        <validation-provider #default="{ errors }" name="Data de Início do Envio" rules="required">
          <b-form-group
            label="Data de Início do Envio*"
            label-for="data-inicio-envio"
            :state="errors.length > 0 || form.errors.dataInicioEnvio ? false : null"
            description="Essa data define que as vacinações feitas a partir dela serão enviadas."
          >
            <b-form-datepicker
              id="data-inicio-envio"
              :value="form.dataInicioEnvio"
              @input="$emit('update:dataInicioEnvio', $event)"
              :hide-header="true"
              placeholder="00/00/0000"
              label-help="Selecione a data"
              :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
              locale="pt-BR"
              :min="new Date()"
              :disabled="!permiteGerenciar"
            />
            <small v-if="errors[0]" class="text-danger d-block">Este campo é de preenchimento obrigatório.</small>
            <small v-if="form.errors.dataInicioEnvio" class="text-danger">{{ form.errors.dataInicioEnvio }}</small>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="6" v-if="form.periodicidade === 'Semanal'">
        <validation-provider #default="{ errors }" name="Dia da Semana para Execução" rules="required">
          <b-form-group
            label="Dia da Semana para Execução*"
            label-for="diasSemanaExecucao"
            :state="errors.length > 0 || form.errors.numeroDiaSemana ? false : null"
          >
            <v-select
              id="diasSemanaExecucao"
              :value="form.numeroDiaSemana"
              @input="$emit('update:numeroDiaSemana', $event)"
              :options="optionsDiasSemana"
              :clearable="false"
              placeholder="Selecione"
              class="bg-white"
              label="value"
              :reduce="option => option.key"
              :get-option-label="getDiaSemanaLabel"
              :disabled="!permiteGerenciar"
            >
              <span slot="no-options">Nenhuma opção disponível.</span>
            </v-select>
            <small v-if="errors[0]" class="text-danger d-block">Este campo é de preenchimento obrigatório.</small>
            <small v-if="form.errors.numeroDiaSemana" class="text-danger">{{ form.errors.numeroDiaSemana }}</small>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>

    <b-row class="mt-2">
      <b-col cols="12">
        <strong class="text-warning">
          O envio de vacinação para o RNDS ocorrerá automaticamente às 20h, a partir da data definida e de acordo com a periodicidade escolhida.
        </strong>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { BRow, BCol, BFormGroup, BFormDatepicker } from 'bootstrap-vue';
import { ValidationProvider } from 'vee-validate';
import {required} from '@validations';
import vSelect from 'vue-select';

export default {
  name: 'AgendamentoEnvio',
  components: { BRow, BCol, BFormGroup, BFormDatepicker, ValidationProvider, vSelect },
  props: {
    form: { type: Object, required: true },
    permiteGerenciar: { type: Boolean, default: false }
  },
  data() {
    return {
      required,
      optionsPeriodicidade: ['Diária', 'Semanal', 'Mensal'],
      optionsDiasSemana: [
        { key: 1, value: 'Domingo' },
        { key: 2, value: 'Segunda-feira' },
        { key: 3, value: 'Terça-feira' },
        { key: 4, value: 'Quarta-feira' },
        { key: 5, value: 'Quinta-feira' },
        { key: 6, value: 'Sexta-feira' },
        { key: 7, value: 'Sábado' }
      ]
    };
  },
  methods: {
    getDiaSemanaLabel(option) {
      if (typeof option === 'number') {
        const dia = this.optionsDiasSemana.find(o => o.key === option);
        return dia ? dia.value : option;
      }
      return option.value || '';
    }
  }
};
</script>
